import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { color, image } from '@/theme';
import { PrimaryButton } from '@/components/button';
import { RegularText } from '@/components/text';
import { Image } from '@/components/shared';
import { SelectInput } from '@/components/input';
import { ButtonContent, ButtonWrapper } from '@/pages/inquiry/inquryStyles';
import {
  useGetArenaEventCategory,
  useGetBusinessCategory,
  useGetMeetingEventCategory,
} from '@/hooks/CommonRequests';

const InquiryStepOne = ({ watch, control, errors, setValue }) => {
  const { search } = useLocation(); //바뀐 부분

  const categoryParams = new URLSearchParams(search).get("category");

  const { data: businessCategory } = useGetBusinessCategory();
  const { data: arenaEventCategory } = useGetArenaEventCategory();
  const { data: meetingEventCategory } = useGetMeetingEventCategory();

  useEffect(() => {
    if(categoryParams) {
      setValue("business_key", businessCategory?.find((el) => el.code_id === categoryParams).code_value)
    }
  }, [businessCategory, categoryParams, setValue]);

  return (
    <>
      <SelectInput
        control={control}
        errors={errors}
        name="business_key"
        arr={businessCategory}
        label="lang-business"
        required
      />

      <SelectInput
        control={control}
        errors={errors}
        name="event_type_key"
        arr={watch('business_key') === '1' ? arenaEventCategory : meetingEventCategory}
        label="lang-type-of-event"
        required
      />

      <ButtonWrapper>
        <PrimaryButton type="submit" width="92%">
          <ButtonContent>
            <RegularText id="lang-inquiry-next" color={color.base_white} />

            <Image src={image.arrowRight.default} width="1.8rem" height="1.4rem" />
          </ButtonContent>
        </PrimaryButton>
      </ButtonWrapper>
    </>
  );
};

export default InquiryStepOne;
